import { Injectable, ElementRef } from '@angular/core';
import { BaseModalService } from 'base';

@Injectable({ providedIn: 'root' })
export class BaseCustomerServiceProviderSelectService {
  constructor(private modalService: BaseModalService) {}

  openInquiryVisibilityAndNotificationsModal(modal: ElementRef) {
    return this.modalService.open(
      {
        headText: 'selectDeselectServiceProvider.title',
        bodyTemplate: modal,
        hideFooter: true,
      },
      {
        backdrop: 'static',
        size: 'lg',
      }
    );
  }
}
